webpackJsonp([1],{

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(299);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9b6db1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(342);
function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(89)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d9b6db1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9b6db1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    productsOfCategory: function productsOfCategory() {
      return this.$store.getters.productsOfCategory(this.$route.params.id);
    }
  },
  created: function created() {
    console.log(this.$store.getters.productsOfCategory() + '=================');
  },

  name: 'Index'
});

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(341);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(273)("0cdc2743", content, true, {});

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(90)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Index.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-5",attrs:{"xs12":""}},[_c('h2',[_vm._v(_vm._s(_vm.$route.params.id))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.productsOfCategory),function(product,index){return _c('v-flex',{key:index,attrs:{"xs":"","md3":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-img',{attrs:{"height":"150px","src":product.productImg,"lazy-src":product.productImg,"aspect-ratio":"1"}}),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"pr-3 pl-3 pt-2 pb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-1",staticStyle:{"line-height":"30px"},attrs:{"xs12":""}},[_c('div',[_c('b',[_vm._v(_vm._s(product.productName))])]),_vm._v(" "),_c('div',{staticClass:"primary--text"},[_vm._v(_vm._s(product.productProducer))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(product.soldAs)+" ("+_vm._s(product.soldAsOf)+")")])]),_vm._v(" "),_c('v-flex',{staticClass:"pa-2",attrs:{"xs12":""}},[_c('div',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm._f("currency")(product.productPrice)))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","xs12":"","wrap":"","align-center":""}},[_c('v-btn',{staticClass:"primary",attrs:{"medium":"","block":"","dark":""},on:{"click":function($event){_vm.addToCart(product)}}},[_c('b',[_vm._v("Ajoutez")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("shopping_cart")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("favorite_outline")])],1)],1)],1)],1)],1)],1)],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.2e04fa9764e09cbcf155.js